module.exports = __webpack_public_path__ + "img/hos1.b631df2b.png";